import { Alert, Box, Tab, Tabs, Typography } from "@mui/material";
import { useParams, useNavigate, useLocation, Outlet, Link } from "react-router-dom";
import { JSX, memo, useCallback, useEffect, useMemo, useState } from "react";
import Assessments from "./assessment/admin/preview";
import Collections from "./library/admin/preview";
import { Assessment } from "../../models/assessment";
import { Collection } from "../../models/collection";
import Overview from "./overview/overview";
import { Collaborator } from "../../models/collaborator";
import NavBarLayout from "../../components/nav-bar-layout";
import Lectures from "./lecture/admin/preview";
import { useDomainActions } from "../../hooks/useDomainActions";
import BackdropLoader from "../../components/backdrop-loader";
import isHubActivated from "../../utils/is-hub-activated";

type TabItem = {
  label: string;
  value: string;
};

const tabs: TabItem[] = [
  { label: "Overview", value: "overview" },
  { label: "Lectures", value: "lectures" },
  { label: "Assessments", value: "assessments" },
  { label: "Library", value: "library" }
];

function ClassRoom() {
  const location = useLocation();
  const navigate = useNavigate();

  const { hub, getHub } = useDomainActions();


  const currentTab = location.hash.replace("#", "") || "overview";

  const handleTabChange = (_event: React.SyntheticEvent, newValue: string) => {
    navigate(`#${newValue}`);
  };

  useEffect(() => {
    const loadHub = async () => {
      if (!hub) await getHub();
    };
    loadHub();
  }, [hub]);



  return (
    <NavBarLayout>
       {(isHubActivated(hub) !== null && !isHubActivated(hub)) && (
        <Box sx={{ mb: 2 }}>
          <Alert severity="warning" sx={{ borderRadius: 2 }}>
            <Typography variant="body2" fontWeight={500}>
              Hub is not activated.{' '}
              <Link
                to="/account#hub"
              >
                Click here to activate
              </Link>
            </Typography>
          </Alert>
        </Box>
       )}
      <Box
        sx={{
            display: "flex",
            justifyContent: "center",
            overflowX: "auto",
            overflowY: "hidden",
            flexDirection: "row",
        }}
      >
        <Tabs
            value={currentTab}
            onChange={handleTabChange}
            textColor="primary"
            indicatorColor="primary"
            variant="scrollable"
            scrollButtons="auto"
        >
            {tabs.map((tab) => (
              <Tab key={tab.value} label={tab.label} value={tab.value} />
            ))}
        </Tabs>
      </Box>

      <Box marginTop={2}>
        {currentTab === "overview" && (
          <Overview />
        )}

        {currentTab === "assessments" && (
          <Assessments hubActive={isHubActivated(hub)}/>
        )}

        {currentTab === "lectures" && (
          <Lectures hubActive={isHubActivated(hub)}/>
        )}


        {currentTab === "library" && (
          <Collections hubActive={isHubActivated(hub)}/>
        )}



        
      </Box>
    </NavBarLayout>
  );
}

export default (ClassRoom);